import Accordion from '@carvana/ds-accordion';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useCallback, useContext } from 'react';
import Markdown from 'react-markdown';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { SortedArticle } from '~/contracts/flp/Article';

type OwnProps = {
  page: string;
  data: SortedArticle;
};

export default function AccordionPanel({ page, data }: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);

  const handleOpen = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) return;

      const events =
        page === 'marketing'
          ? {
              eventable: ANALYTICS_EVENTS.MARKETING.CLICKS_FAQ,
              datadog: DATADOG_EVENTS.MARKETING.CLICKS_FAQ
            }
          : {
              eventable: ANALYTICS_EVENTS.PREQUALIFIED.CLICKS_FAQ,
              datadog: DATADOG_EVENTS.PREQUALIFIED.CLICKS_FAQ
            };
      const heading = data?.heading;
      const key = data?.key;
      datadogRum.addAction(events.datadog, { heading, key });
      trackEvent(events.eventable, { heading, key });
    },
    [data?.heading, data?.key, page, trackEvent]
  );

  return (
    <Accordion
      classes={{
        container: 'py-0',
        content: 't-body-sm pb-2xl',
        header: 'pt-2xl'
      }}
      testId="faq-panel"
      headerText={data.heading}
      onExpandedChange={handleOpen}
    >
      <div className="flex flex-col gap-2xl pt-2xl">
        <Markdown
          components={{
            a: ({ node: _node, ...props }) => (
              <a
                {...props}
                className="t-link-sm text-text-primary"
                data-testid="faq-content-link"
              />
            )
          }}
        >
          {data.content}
        </Markdown>
      </div>
    </Accordion>
  );
}
